// src/components/profile/roi/CalculationBreakdown.jsx
import React from 'react';
import { Calculator } from 'lucide-react';

export default function CalculationBreakdown({
  baseBenefitsY1,
  multiplier,
  adjustedBenefitsY1,
  investmentY1
}) {
  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return '$0';
    const absValue = Math.abs(value);
    if (absValue >= 1000000) return `$${(value/1000000).toFixed(2)}M`;
    if (absValue >= 1000) return `$${Math.round(value/1000)}K`;
    return `$${value.toFixed(0)}`;
  };
  
  const netValue = adjustedBenefitsY1 - investmentY1;
  const roiPct = investmentY1 > 0 ? ((netValue / investmentY1) * 100).toFixed(0) : 0;
  
  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-6">
      <div className="flex items-center gap-2 mb-3">
        <Calculator className="w-5 h-5 text-gray-600" />
        <h4 className="font-semibold text-gray-900">Calculation Breakdown</h4>
      </div>
      
      <div className="space-y-2 font-mono text-sm">
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Base Year 1 Benefits:</span>
          <span className="font-bold">{formatCurrency(baseBenefitsY1)}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Scenario Multiplier:</span>
          <span className="font-bold text-blue-600">× {multiplier}</span>
        </div>
        
        <div className="flex items-center justify-between border-t pt-2">
          <span className="text-gray-600">Adjusted Benefits:</span>
          <span className="font-bold text-green-600">{formatCurrency(adjustedBenefitsY1)}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Investment (constant):</span>
          <span className="font-bold text-red-600">-{formatCurrency(investmentY1)}</span>
        </div>
        
        <div className="flex items-center justify-between border-t pt-2">
          <span className="text-gray-700 font-semibold">Net Value:</span>
          <span className="font-bold text-gray-900">{formatCurrency(netValue)}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-gray-700 font-semibold">ROI:</span>
          <span className="font-bold text-gray-900">{roiPct}%</span>
        </div>
      </div>
      
      <div className="mt-3 text-xs text-gray-500">
        * Investment remains constant across all scenarios
      </div>
    </div>
  );
}